export default __webpack_public_path__ + "static/media/juego_edocuenta_pierde.5c60e80d.png";